import { Box, Grid, useMediaQuery } from "@mui/material";
import { setLibraryRecentSearch } from "components/app/App.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import Plans from "components/common/plans/plans.layout";
import ScrollAwareHeader from "components/common/ScrollAwareHeader";
import { fetchBookmarkPlansAsync, setBookmarkedPlanList } from "components/features/library/Bookmark/Bookmark.slice";
import CreateMyPlan from "components/features/MyPlans/Create";
import { useEffect, useState } from "react";
import { theme as MUITheme } from "styles/Theme";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE, allPlansType } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { Bookmarkplans } from "./Bookmark";
import "./index.scss";

function Index() {
  const dispatch = useAppDispatch();
  const [pageNo, setPageNo] = useState(1);
  const bookmarkPlansList: any = useAppSelector((state: any) => state.bookmarkedPlans.bookmarkedPlansList);
  const bookmarkedPlanIdList: any = useAppSelector((state: any) => state.bookmarkedPlans.list);
  const totalRecords: any = useAppSelector((state: any) => state.bookmarkedPlans.totalRecords);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const innCodeBookmark: Bookmarkplans = bookmarkedPlanIdList?.find((item: any) => item?.innCode === innCode);
  const bookmarkPlanIds = innCodeBookmark ? innCodeBookmark.cmsId : [];
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[filterPage.libraryBookmarkedPlansDisplay]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const libraryRecentSearch = useAppSelector((state) => state.app.libraryRecentSearch);
  const searchText = globalFiltersforPage?.searchText;
  const isMobileScreen = useMediaQuery(MUITheme.breakpoints.down("md"));
  const { isCorp } = useAppSelector((state) => state.app.loggedInUserDetails);
  const isConsultant = useAppSelector((state) => state.app.loggedInUserDetails.isConsultant);

  const getProps = (page?: number) => {
    return {
      filter: {
        innCode,
        ids: bookmarkPlanIds,
        ...formattedFilterRequestPayload
      },
      pagination: {
        page: page ?? pageNo + 1,
        size: PAGE_SIZE
      },
      searchText: searchText,
      planType:
        formattedFilterRequestPayload["planType"]?.length > 0
          ? formattedFilterRequestPayload["planType"]
          : [allPlansType]
    };
  };

  useEffect(() => {
    const props: any = getProps(1);
    if (searchText) props.sort = { property: "relevance", direction: "ASC" };
    if (bookmarkPlanIds.length > 0) {
      dispatch(fetchBookmarkPlansAsync(props));
      setPageNo(1);
    } else dispatch(setBookmarkedPlanList());
  }, [dispatch, bookmarkedPlanIdList, innCode, searchText, filterRequestPayload]);

  const fetchMore = () => {
    const props = getProps();
    dispatch(fetchBookmarkPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  const getScrollHeaderContent = () => {
    return (
      <ScrollAwareHeader sx={{}} elementId="350">
        <Grid display="flex" alignItems="center" width="100%" gap="8px">
          <Box flex="1" minWidth={0}>
            <GlobalFilters
              isSearchBarVisible
              page={filterPage.libraryBookmarkedPlansDisplay}
              searchedText={searchText}
              isPreDefinedNav={true}
              setRecentSearch={setLibraryRecentSearch}
              libraryRecentSearch={libraryRecentSearch}
            />
          </Box>
          {!isCorp && !isConsultant && !isMobileScreen && <CreateMyPlan />}
        </Grid>
      </ScrollAwareHeader>
    );
  };

  return (
    <>
      {getScrollHeaderContent()}
      <GlobalFilters
        isSearchBarVisible
        page={filterPage.libraryBookmarkedPlansDisplay}
        searchedText={searchText}
        isPreDefinedNav={true}
        setRecentSearch={setLibraryRecentSearch}
        libraryRecentSearch={libraryRecentSearch}
      />
      <GlobalFilterDescription
        page={filterPage.libraryBookmarkedPlansDisplay}
        bgColor={tokens.Background.General.Primary}
      />
      <Plans plansList={bookmarkPlansList} totalList={totalRecords} loadMore={fetchMore}></Plans>
    </>
  );
}

export default Index;
